import styled, { keyframes, css } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-5px);
  }
`;

export const DropdownContainer = styled.div`
  position: relative;
`;

export const DropdownMenu = styled.div<{ isVisible: boolean }>`
  position: absolute;
  background: rgba(255, 251, 248, 1);
  border: 1px solid rgba(198, 166, 145, 1);
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  min-width: 150px;
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  z-index: 100;
  
  // Animation applied
  animation: ${({ isVisible }) =>
  isVisible
    ? css`${fadeIn} 0.2s ease-out`
    : css`${fadeOut} 0.15s ease-in`};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
`;
